<template>
  <div>
    <v-container fluid>
      <material-card
        icon="mdi-clipboard-text"
        inline
        title="View Student Subject Diary"
      >
        <v-card-actions>
          <router-link :to="{ name: 'viewStudentSubjectDiary' }">
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              elevation="1"
              absolute
              top
              right
            >
              <v-icon left>mdi-arrow-left</v-icon>back
            </v-btn>
            <v-btn
              v-else
              fixed
              right
              fab
              small
              color="grey lighten-2"
              elevation="1"
              class="mr-n2 mt-10"
              style="opacity: 0.6"
            >
              <v-icon>mdi-arrow-left</v-icon></v-btn
            >
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <form @submit.prevent="save">
            <v-row>
              <v-col cols="12">
                <label class="font-weight-medium body-2"> Class Work </label>
                <!-- <ckeditor read-only v-model="classwork" ref="ckeditorRef1"></ckeditor> -->
                <!-- <textarea class="input" rows="3" readonly v-model="classwork" ref="ckeditorRef"></textarea> -->
                <quill-editor
                  :disabled="true"
                  :options="options"
                  v-model="classwork"
                  theme="snow"
                  ref="myQuillEditor"
                >
                </quill-editor>
              </v-col>
              <v-col cols="12">
                <label class="font-weight-medium body-2"> Home Work </label>
                <!-- <ckeditor read-only v-model="homework" ref="ckeditorRef2"></ckeditor> -->
                <!-- <textarea class="input" rows="3" readonly v-model="homework" ref="ckeditorRef"></textarea> -->
                <quill-editor
                  :disabled="true"
                  :options="options"
                  v-model="homework"
                  theme="snow"
                  ref="myQuillEditor"
                >
                </quill-editor>
              </v-col>

              <v-col cols="12">
                <label class="font-weight-medium body-2"> Description </label>
                <!-- <ckeditor read-only v-model="description" ref="ckeditorRef3"></ckeditor> -->
                <!-- <textarea readonly class="input" rows="3" v-model="description" ref="ckeditorRef"></textarea> -->
                <quill-editor
                  :disabled="true"
                  :options="options"
                  v-model="description"
                  theme="snow"
                  ref="myQuillEditor"
                >
                </quill-editor>
              </v-col>
              <v-col cols="12" v-if="dropFile1.length > 0">
                <v-col cols="12" md="4" v-if="dropFile1.length > 0">
                  <label class="warning--text">
                    Already Uploaded Documents</label
                  >
                  <div>
                    <v-chip
                      class="mr-2 mt-2"
                      color="primary"
                      v-for="(file, i) in dropFile1"
                      :key="i"
                      label
                      outlined
                      @click="download(file.urlPath)"
                    >
                      {{ file.name }}
                    </v-chip>
                  </div>
                </v-col>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
// import Utils from '@/utils'
// import Vue from 'vue'
// import CKEditor from 'ckeditor4-vue'
// Vue.use(CKEditor)
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'showStudentSubjectDiary',
  props: ['studentDiaryID'],
  components: { MaterialCard, quillEditor },
  data () {
    return {
      total: 0,
      dropFile: [],
      classworkfile: [],
      homeworkfile: [],
      discriptionfile: [],
      viewclassworkfile: [],
      viewhomeworkfile: [],
      viewdiscriptionfile: [],
      classwork: '',
      discription: '',
      type: '',
      title: '',
      homework: '',
      description: '',
      studentDiary: [],
      documentData: [],
      hasClicked: false,
      loader: true,
      sendData: {},
      selectedfranchiseeID: [],
      dropFile1: [],
      isLoading: false,
      options: {
        debug: 'info',
        modules: {
          toolbar: []
        },
        readOnly: true,
        theme: 'snow'
      }
    }
  },

  async created () {
    await this.studentSubjectDiary()
    await this.studentSubjectDiaryDocuments()
  },
  beforeRouteLeave (to, from, next) {
    next()
  },
  methods: {
    studentSubjectDiary: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/studentSubjectDairy/${this.studentDiaryID}`
        )
        this.studentDiary = data
        this.classwork = this.studentDiary.classWork
        this.description = this.studentDiary.description
        this.homework = this.studentDiary.homeWork
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    studentSubjectDiaryDocuments: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/studentSubjectDairy/${this.studentDiaryID}`
        )
        this.documentData = data
        this.dropFile1 = this.documentData.studentSubjectDairyDocuments
        if (this.dropFile1) {
          this.dropFile1.forEach((docID) => {
            docID.name = docID.urlKey.substring(
              docID.urlKey.lastIndexOf('/') + 1
            )
          })
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },

    save: async function () {},
    download: async function (i) {
      try {
        let url = await http.get(
          `${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`
        )
        window.open(url.data)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    }
  }
}
</script>
<style scoped>
textarea {
  background-color: #ffffff;
  border-color: #dbdbdb;
  border-radius: 4px;
  color: #363636;
  height: 9.5rem;
}
</style>
